<template>
  <div id="main">
    <el-container>
      <el-main>
        <div style="height: 100%;width: 100%">
          <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="创建用户" name="1">
              <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign"
                       style="width: 50%;margin: auto;">
                <el-form-item label="用户邮箱">
                  <el-input  v-model="email" class="input-box" placeholder="blackbox@exmaple.com"></el-input>
                </el-form-item>
                <el-form-item label="部门名称">
                  <el-input v-model="deptName" class="input-box" placeholder="请输入部门名称"></el-input>
                </el-form-item>
                <el-form-item label="用户密码">
                  <el-input v-model="pwd" class="input-box" type="password"
                            placeholder="至少6位，同时包含大、小写字母和数字" onpaste="return false" oncontextmenu="return false"
                            oncopy="return false" oncut="return false"></el-input>
                </el-form-item>
                <el-form-item label="确认密码">
                  <el-input v-model="pwdAgain" class="input-box" type="password"
                            placeholder="请与上方保持一致" onpaste="return false" oncontextmenu="return false"
                            oncopy="return false" oncut="return false"></el-input>
                </el-form-item>
                <el-button type="primary" class="login-button" @click="toLogin">创建用户</el-button>
                <span class="warn">{{ deptNameWarn }}</span>
                <span class="warn">{{ emailWarn }}</span>
                <span class="warn">{{ pwdWarn }}</span>
                <span class="warn">{{ pwdAgainWarn }}</span>
              </el-form>
            </el-tab-pane>


<!--            <el-tab-pane label="分配角色" name="2">-->
<!--              <el-main>-->
<!--                <template>-->
<!--                  <el-table-->
<!--                      :data="userList"-->
<!--                      style="width: 100%"-->
<!--                      height="450"-->
<!--                      border-->
<!--                      stripe>-->
<!--                    <el-table-column-->
<!--                        fixed-->
<!--                        prop="userName"-->
<!--                        label="用户邮箱"-->
<!--                        width="250">-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                        prop="roleName"-->
<!--                        label="角色名"-->
<!--                        width="640">-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                        fixed="right"-->
<!--                        label="操作"-->
<!--                        width="130">-->
<!--                      <template slot-scope="scope">-->
<!--                        <el-button type="primary" icon="el-icon-plus" @click="handleEdit(scope.$index, scope.row)">分配</el-button>-->
<!--                      </template>-->

<!--                    </el-table-column>-->
<!--                  </el-table>-->
<!--                </template>-->
<!--              </el-main>-->

<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="分配设备" name="3">-->
<!--              <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign"-->
<!--                       style="width: 50%;margin: auto;">-->
<!--                <el-form-item label="用户名字">-->
<!--                  <el-input v-model="formLabelAlign.name"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="用户邮箱">-->
<!--                  <el-input v-model="formLabelAlign.region"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="用户密码">-->
<!--                  <el-input v-model="formLabelAlign.type"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="确认密码">-->
<!--                  <el-input v-model="formLabelAlign.type"></el-input>-->
<!--                </el-form-item>-->
<!--              </el-form>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="分配项目" name="4">-->
<!--              <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign"-->
<!--                       style="width: 50%;margin: auto;">-->
<!--                <el-form-item label="用户名字">-->
<!--                  <el-input v-model="formLabelAlign.name"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="用户邮箱">-->
<!--                  <el-input v-model="formLabelAlign.region"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="用户密码">-->
<!--                  <el-input v-model="formLabelAlign.type"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="确认密码">-->
<!--                  <el-input v-model="formLabelAlign.type"></el-input>-->
<!--                </el-form-item>-->
<!--              </el-form>-->
<!--            </el-tab-pane>-->
          </el-tabs>
        </div>
      </el-main>
    </el-container>

<!--    以下为测试代码-->
    <el-dialog
        title='分配角色'
        :visible.sync="dialogVisible"
        width="50%"
        :append-to-body="true">
      <span>分配用户{{editRole.userName}}的角色</span>
      <el-card class="box-card">
        <el-checkbox-group v-model="editRoleList">
          <el-checkbox v-for="(role,index) in roleList"
                       :key="index"
                       :label="role.roleName"
          ></el-checkbox>
        </el-checkbox-group>
      </el-card>
      <span slot="footer" class="dialog-footer">
                          <el-button @click="dialogVisible = false">取 消</el-button>
                          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                        </span>
    </el-dialog>

  </div>
</template>

<script>
  import authorityApi from "../../api/authority";
  import { mapActions, mapState, mapGetters} from 'vuex'
  export default {
        data() {
            return {
                activeName: '1',
                deptName: '',
                email: '',
                pwd: '',
                pwdAgain: '',
                deptNameWarn: '',
                emailWarn: '',
                pwdWarn: '',
                pwdAgainWarn: '',
                dialogVisible: false,

                // 以下为测试变量
                labelPosition: 'right',
                formLabelAlign: {
                    name: '',
                    region: '',
                    type: '',
                },
                editRole:{},
                editRoleList:[],
                gridData:'',
            };
        },
        methods: {
            handleClick(tab) {
                this.activeName = tab.name;
            },
            toLogin() {
                const self = this;
                const { deptName, email, pwd, pwdAgain } = this;
                self.deptNameWarn = '';
                self.emailWarn = '';
                self.pwdWarn = '';
                self.pwdAgainWarn ='';
                if (email === '') {
                    self.emailWarn = '请输入电子邮箱';
                } else if (self.isEmail(email) === false) {
                    self.emailWarn = '请输入正确的电子邮箱';
                } else if (deptName === '') {
                    self.deptNameWarn = '请输入部门名称';
                } else if (pwd === '') {
                    self.pwdWarn = '请输入密码';
                } else if (self.isPwd(pwd) === false) {
                    self.pwdWarn = '6位以上，请务必包含大写字母、小写字母以及数字';
                    self.pwd = '';
                    self.pwdAgain = '';
                } else if (pwdAgain === '') {
                    self.pwdAgainWarn = '请再次输入密码';
                } else if (pwdAgain !== pwd) {
                    self.pwdAgainWarn = '两次密码输入不一致，请重新输入';
                    self.pwd = '';
                    self.pwdAgain = '';
                } else {
                    const userName = self.email
                    const password = self.pwd
                    const deptName = self.deptName
                    authorityApi.createUser(userName,password,deptName).then((res)=>{
                        self.$message({
                            type: 'success',
                            message: `你的信息已经提交，等待管理员进行审核，结果将以邮件告知${email}`,
                        });
                        self.deptName=''
                        self.email=''
                        self.pwd=''
                        self.pwdAgain=''
                    }).catch((err) =>{
                        this.$message.error(`用户创建失败 (${err[0]})：${err[1]}`)
                    })
                }
            },
            isEmail(mail) {
                const filter = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
                if (filter.test(mail)) {
                    return true;
                }
                return false;
            },
            isPwd(pwd) {
                const filter = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/;
                if (filter.test(pwd)) {
                    return true;
                }
                return false;
            },
            //以下为测试函数
            handleEdit(index,row){
                this.dialogVisible=true
                this.editRole=Object.assign({},row)
            },
            ...mapActions('Authority',['getUserList','getRoleList']),
        },
        mounted(){
            //获取用户信息
            this.getUserList().catch((err)=>{
                this.$message.error(`用户查询失败 (${err[0]})：${err[1]}`)
            })
            //获取角色信息
            this.getRoleList().catch((err)=> {
                this.$message.error(`角色信息获取失败 (${err[0]})：${err[1]}`)
            })
        },
      computed:{
          ...mapState('Authority',['userList','roleList']),
          //获取部门信息
          ...mapGetters('Authority',['deptList'])
      }
    };
</script>

<style scoped>

  #main {
    width: 100%;
    height: 100%;
    background-color: #F9F9F9;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container {
    height: 100%;
    width: 100%;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }

  .warn {
    color: red;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/authority/userCreate.vue